import { SdsBreadcrumbs } from '../sds-breadcrumbs.lit';
import { removeAllChildrenSync } from '../../utilities/dom';
export class BreadcrumbsOverflowManager {
    constructor(items, container, breadcrumbs) {
        this._hiddenItemsCount = 0;
        this._items = items;
        this._container = container;
        this._breadcrumbs = breadcrumbs;
    }
    calculateOverflow() {
        var _a;
        const prevItemsCount = this._hiddenItemsCount;
        if (this.hasOverflow()) {
            this.revealThreeDot();
            this.hideBreadcrumbsItems();
        }
        else {
            this.showBreadcrumbsItems();
            if (this._hiddenItemsCount === 0) {
                (_a = this._threeDotItem) === null || _a === void 0 ? void 0 : _a.closeContextMenu();
                this.hideThreeDot();
            }
        }
        if (this._hiddenItemsCount !== prevItemsCount) {
            this.clearMenu();
            this.setCmItems();
        }
    }
    showBreadcrumbsItems() {
        while (!this.hasOverflow() && this._hiddenItemsCount !== 0) {
            const nextItemToShow = this.getNextItem(this._hiddenItemsCount);
            this.showBreadcrumbsItem(nextItemToShow);
            if (this.hasOverflow()) {
                this.hideBreadcrumbsItem(nextItemToShow);
                break;
            }
            else {
                --this._hiddenItemsCount;
            }
        }
    }
    hideBreadcrumbsItems() {
        while (this.hasOverflow() && this._hiddenItemsCount < this._items.length - 1) {
            const nextItemToHide = this.getNextItem(this._hiddenItemsCount + 1);
            this.hideBreadcrumbsItem(nextItemToHide);
            ++this._hiddenItemsCount;
        }
    }
    getNextItem(nextItem) {
        return this.isFirstItemNext(nextItem) ? this._items[0] : this._items[nextItem];
    }
    revealThreeDot() {
        if (!this._threeDotItem) {
            this.createThreeDotItem();
        }
        this.showThreeDot();
    }
    createThreeDotItem() {
        this._threeDotItem = document.createElement('sds-breadcrumbs-dropdown');
        this._threeDotItem.overflowButton = true;
        this._breadcrumbs.insertBefore(this._threeDotItem, this._items[1]);
    }
    setCmItems() {
        if (this.isFirstItemNext(this._hiddenItemsCount)) {
            for (let i = 0; i < this._hiddenItemsCount; ++i) {
                this.appendCmItemToThreeDot(i);
            }
        }
        else {
            for (let i = 1; i <= this._hiddenItemsCount; ++i) {
                this.appendCmItemToThreeDot(i);
            }
        }
    }
    clearMenu() {
        if (this._threeDotItem) {
            removeAllChildrenSync(this._threeDotItem);
        }
    }
    appendCmItemToThreeDot(index) {
        var _a;
        (_a = this._threeDotItem) === null || _a === void 0 ? void 0 : _a.appendChild(this.createCmItem(this._items[index].label, this._items[index].getAttribute(SdsBreadcrumbs.IDENTIFIER) || `${index}`));
    }
    createCmItem(name, identifier) {
        const cmItem = document.createElement('sds-cm-item');
        cmItem.name = name;
        cmItem.setAttribute(SdsBreadcrumbs.BREADCRUMBS_IDENTIFIER, identifier);
        return cmItem;
    }
    showThreeDot() {
        if (this._threeDotItem) {
            this._threeDotItem.style.display = '';
        }
    }
    hideThreeDot() {
        if (this._threeDotItem) {
            this._threeDotItem.style.display = 'none';
        }
    }
    showBreadcrumbsItem(item) {
        item.style.display = '';
    }
    hideBreadcrumbsItem(item) {
        item.style.display = 'none';
    }
    isFirstItemNext(nextItemsCount) {
        return nextItemsCount === this._items.length - 1;
    }
    hasOverflow() {
        return this._container.scrollWidth - this._container.clientWidth !== 0;
    }
}
